module.exports = __webpack_public_path__ + "media/images/forms-icons/monetary-icon-1d57d5df1a17495a33f62036c3866207.svg";